(ns ui.view.card.value-creations.view
  (:require
   [clojure.string :as string]
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.view.modals.confirmation.view :as confirmation]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.value-creation.view :as value-creation-modal]
   [re-frame.core :as rf]
   [ui.components.button.view :as button]
   [ui.view.card.entity-list.view :as entity-list-view]
   [ui.view.card.event :as common-event]
   [ui.view.card.shared-components.card-container :as card-container]
   [ui.view.card.shared-components.card-title :as card-title]
   [ui.view.card.shared-components.entity-peek :as entity-peek]
   [ui.view.card.shared-components.entity-table :as entity-table]
   [ui.view.card.shared-components.full-screen-card :as full-screen-card] ;; TODO: remove these once we have a new entity editor
   [ui.view.card.shared-components.view :as card-shared]
   [ui.view.card.sub :as common-sub]
   [ui.view.card.value-creations.event :as event]
   [ui.view.card.value-creations.sub :as sub]))

(defn add-new-value-creation-button
  [{:keys [preview-mode? primary-button? ctx] :as _props}]
  (let [component (if primary-button?
                    button/sm-primary-solid
                    button/sm-secondary-hollow)]
    [component
     {:disabled? preview-mode?
      :on-click (fn []
                  (modals/open-modal!
                   value-creation-modal/modal-key
                   {:containing-entity-id (:entity-id ctx)
                    :on-save-success! (fn []
                                        (rf/dispatch [::event/refetch-data ctx]))}))}
     [:i {:class "fal fa-plus"}]
     (loc/tr :add-value-creation)]))

(defn empty-state-view
  [props]
  [:div
   {:class "flex flex-col items-center gap-4 py-5"}
   [:div
    {:class "relative"}
    [:i {:class "fal fa-comments-dollar text-5xl font-thin"}]
    [:div
     {:class "absolute -bottom-1 -right-2 flex items-center justify-center bg-base-light rounded-full w-7 h-7"}
     [:i {:class "fal fa-plus text-2xl"}]]]
   [:p
    {:class "text-lg font-semibold"}
    (loc/tr :no-value-creations-yet)]
   [:div
    {:class "flex justify-center"}
    [add-new-value-creation-button
     (assoc props :primary-button? true)]]])

(defn table-view
  [{:keys [card ctx]}]
  (let [table-data @(rf/subscribe [::sub/table-data ctx])
        columns (-> card :card/config :table-config :columns)
        peek-entity-id @(rf/subscribe [::common-sub/entity-peek-entity-id ctx])]
    [:div
     {:class "flex flex-col gap-5 grow"}
     [entity-table/view
      {:columns columns
       :config (-> card :card/config :table)
       :data table-data
       :selected-row-id peek-entity-id
       :on-row-clicked (fn [{:keys [entity-id]}]
                         (rf/dispatch [::common-event/open-entity-peek-or-close-if-already-open ctx entity-id]))}]]))

(defn entity-peek-view
  [{:keys [card preview-mode? ctx]}]
  (let [open? @(rf/subscribe [::common-sub/entity-peek-open? ctx])
        peek-entity-id @(rf/subscribe [::common-sub/entity-peek-entity-id ctx])
        entity-peek-config (-> card :card/config :entity-peek)
        entity-peek-data @(rf/subscribe [::common-sub/entity-peek-data ctx entity-peek-config]) 
        value-creations @(rf/subscribe [::sub/value-creations ctx])]
    [entity-peek/view
     {:open? open?
      :data entity-peek-data
      :entity-type :entity.type/value-creation
      :close (fn []
               (rf/dispatch [::common-event/close-entity-peek ctx]))
      :preview-mode? preview-mode?
      :edit (fn []
              (modals/open-modal!
               value-creation-modal/modal-key
               {:containing-entity-id (:entity-id ctx)
                :entity-id peek-entity-id
                :entity (->> value-creations
                             (cu/filter-by :db/id peek-entity-id)
                             (first))
                :delete-entity! (fn [] (modals/open-modal!
                                        confirmation/modal-key
                                        {:body          [:div
                                                         [:p (loc/tr :confirm-delete-value-creation)]]
                                         :confirm-text  (loc/tr :delete-entity [(string/lower-case (loc/tr :entity.type/value-creation))])
                                         :checkbox-text (loc/tr :confirm-delete-selected-checkbox)
                                         :on-confirm    (fn [_]
                                                          (rf/dispatch [::event/delete-value-creation ctx peek-entity-id]))}))
                :on-save-success! (fn []
                                    (rf/dispatch [::event/refetch-data ctx]))}))}]))

(defn component
  [{:keys [card ctx] :as props}]
  (let [title (:card/title card)
        value-creations-count @(rf/subscribe [::sub/value-creations-count ctx])
        value-creations? (pos? value-creations-count)
        loading? @(rf/subscribe [::common-sub/loading? ctx])]
    [card-container/view
     {}
     [:div
      {:class "flex"}
      [:div
       {:class "flex flex-col gap-2 grow"}
       [:div
        {:class "flex justify-between min-h-12 items-start"}
        [card-title/view title]
        [:div
         {:class "flex gap-2 items-center"}
         (when value-creations?
           [add-new-value-creation-button props])
         [card-shared/expand-card props]]]
       (cond
         loading? [entity-list-view/loading-skeleton]
         value-creations? [table-view props]
         :else [empty-state-view props])]
      [entity-peek-view props]]]))

(defn full-screen-component
  [{:keys [ctx] :as props}]
  (let [value-creations-count @(rf/subscribe [::sub/value-creations-count ctx])
        loading? @(rf/subscribe [::common-sub/loading? ctx])]
    [full-screen-card/view
     props
     [:div
      {:class "flex w-full h-full"}
      (cond
        loading? [entity-list-view/loading-skeleton]
        (pos? value-creations-count) [table-view props]
        :else [empty-state-view props])
      [entity-peek-view props]]]))

(defn view
  [{:keys [full-screen?] :as props}]
  [:<>
   (if full-screen?
     [full-screen-component props]
     [component props])])
